import { render, staticRenderFns } from "./ManualFilters.vue?vue&type=template&id=53fa973e"
import script from "./ManualFilters.vue?vue&type=script&lang=js"
export * from "./ManualFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports